import {Component, OnInit} from "@angular/core";
import {EingabeStepComponent} from "./eingabe.step.component";
import {StepService} from "../../services/step.service";
import {ActivatedRoute, Router} from "@angular/router";
import {WarmwassercheckRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {FormModel} from "../../form/form.model.abstract";


/**
 * Custom step for the input of shower-data
 *
 * @inheritDoc
 */



@Component({
    selector: 'app-step-eingabe-shower-data',
    templateUrl: './eingabe.shower-data.component.html',
    standalone: false
})

export class EingabeShowerDataComponent extends EingabeStepComponent implements OnInit {

  /**
   * list of fomfields
   */
  formFields: {[key: string]: FormModel} = {};

  /**
   * list of shower fields to display
   */
  showerFields: any = [];

  /**
   * Overwrite parent constructor and add some more services.
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param route
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: WarmwassercheckRequestService, protected elementService: ElementService, protected portalService: PortalService, protected route: ActivatedRoute) {
    super(stepService, router, requestService, elementService, portalService, route);
  }


  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // init shower fields
    this.initShowerFields();
  }

  /**
   * initialize dynamically the shower fields based on residents count (bewohneranzahl)
   */
  initShowerFields(): void {
    for (let i = 1; i <= this.anfrage?.userInput?.bewohneranzahl; i++) {
      const fieldName = 'duschen_anzahl_' + i;
      const field = this.formConfig.getField(fieldName);

      this.formFields[fieldName] = field;
      this.showerFields.push(field);
    }
  }

}
